/* ========================================================================
   Data Layer (GTM)
 ========================================================================== */

app.dataLayer = (function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var init = function () {
    const gtmElements = document.querySelectorAll('a[data-gtm-event]');

    gtmElements.forEach((element) => {
      element.addEventListener('click', (e) => {
        let newObject = {};
        let event = element.dataset.gtmEvent ? element.dataset.gtmEvent : '';
        let trackPageUrl = element.dataset.gtmPageUrl ? element.dataset.gtmPageUrl : false;
        let trackDestinationUrl = element.dataset.gtmDestUrl ? element.dataset.gtmDestUrl : false;

        if (event !== '') {
          newObject['event'] = event;
        } else {
          return;
        }

        if (trackPageUrl) {
          newObject['pageUrl'] = window.location.pathname;
        }

        if (trackDestinationUrl) {
          newObject['destinationUrl'] = element.getAttribute('href');
        }

        // DATALAYER
        window.dataLayer.push(newObject);
      });
    });

    const contentButtons = document.querySelectorAll('.js-content-button');
    const contentLinks = document.querySelectorAll('.js-content-link');

    contentButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        // DATALAYER
        window.dataLayer.push({
          event: 'contentClick',
          pageUrl: window.location.pathname,
          destinationUrl: button.getAttribute('href'),
        });
      });
    });

    contentLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        // DATALAYER
        window.dataLayer.push({
          event: 'contentClick',
          pageUrl: window.location.pathname,
          destinationUrl: link.getAttribute('href'),
        });
      });
    });
  };

  var pushEvent = function (eventName, args) {
    if (eventName === '') return;

    args = args || {};

    let gtmEvent = { event: eventName };

    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        gtmEvent[key] = args[key];
      }
    }

    // DATALAYER
    window.dataLayer.push(gtmEvent);
    console.log(gtmEvent);
  };

  // Expose public functions and variables
  return {
    init: init,
    pushEvent: pushEvent,
  };
})();
